import { defineMessages } from 'react-intl'

export default defineMessages({
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  delete: {
    id: 'Delete',
    defaultMessage: 'Delete'
  },
  install: {
    id: 'Install',
    defaultMessage: 'Install'
  },
  update: {
    id: 'Update',
    defaultMessage: 'Update'
  },
  header: {
    id: 'SpaceCustomAppEditPage.Header',
    defaultMessage: 'App Functionality & Features'
  },
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  },
  requiredRadioButtonError: {
    id: 'FormError.Required.RadioButton',
    defaultMessage: 'Please select a choice.'
  },
  invalidImage: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.FormError.invalidImage',
    defaultMessage: 'Please enter a valid Image URL. Valid image types are gif, jpg, jpeg, and png.'
  },
  invalidUrl: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.FormError.InvalidURL',
    defaultMessage: 'Please enter a valid URL with the formatting of https://www.exampleurl.com'
  },
  invalidContactUrl: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.FormError.invalidContactUrl',
    defaultMessage:
      'Please enter a valid Support Contact URL. Email Address format: test.user@example.com or Website format: https://www.exampleurl.com/support'
  },
  audienceError: {
    id: 'Publishing.AudienceStep.Error',
    defaultMessage: 'Audience must have at least one member.'
  },
  validationWarning: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.FormError.validationWarning',
    defaultMessage: 'Please complete all required fields above.'
  },
  referenceGuide: {
    id: 'SpaceCustomAppEditPage.ReferenceGuide',
    defaultMessage: 'Questions, consult our Reference Guide'
  }
})
